import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MessageCircle, BookOpen, Clock } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { ARTICLES } from "../data/articles";
import { waUrl, WA_MESSAGES } from "../lib/api";

export default function ArticlesSection() {
    const navigate = useNavigate();
    return (
        <section id="articles" className="bg-[#F8FAFC] py-20 md:py-28" data-testid="articles-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="max-w-2xl mb-12">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0A1A2F] text-white text-xs font-semibold mb-4">
                        <BookOpen className="w-3.5 h-3.5 text-[#F5A623]" />
                        ARTIKEL & INSIGHT
                    </div>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1A2F] tracking-tight leading-tight">
                        Panduan Realistis Kuliah ke Luar Negeri
                    </h2>
                    <p className="mt-4 text-base text-slate-600 leading-relaxed">
                        Artikel praktis untuk siswa dan orang tua: dari pilihan negara, biaya, beasiswa, visa, sampai cerita alumni.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-5 md:gap-6">
                    {ARTICLES.map((a, i) => {
                        const Icon = a.Icon;
                        return (
                            <motion.article
                                key={a.slug}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.5, delay: i * 0.08 }}
                                onClick={() => navigate(`/artikel/${a.slug}`)}
                                className="group bg-white border border-slate-200 rounded-3xl overflow-hidden hover:shadow-xl hover:border-[#F5A623]/40 transition-all cursor-pointer"
                                data-testid={`article-card-${a.slug}`}
                            >
                                <div className={`relative h-44 bg-gradient-to-br ${a.accent} overflow-hidden`}>
                                    <div className="absolute inset-0 opacity-20 bg-grain" />
                                    <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-[11px] font-bold uppercase tracking-wider text-[#0A1A2F]">
                                        {a.category}
                                    </div>
                                    <div className="absolute bottom-4 right-4 w-14 h-14 rounded-2xl bg-white/15 backdrop-blur-md flex items-center justify-center border border-white/20">
                                        <Icon className="w-7 h-7 text-white" strokeWidth={1.75} />
                                    </div>
                                </div>
                                <div className="p-6 md:p-7">
                                    <h3 className="font-display font-semibold text-lg sm:text-xl text-[#0A1A2F] leading-snug group-hover:text-[#F5A623] transition-colors">
                                        {a.title}
                                    </h3>
                                    <p className="mt-3 text-sm text-slate-600 leading-relaxed line-clamp-2">
                                        {a.excerpt}
                                    </p>
                                    <div className="mt-5 flex items-center justify-between text-xs text-slate-500">
                                        <span className="inline-flex items-center gap-1.5">
                                            <Clock className="w-3.5 h-3.5" /> {a.read}
                                        </span>
                                        <span className="inline-flex items-center gap-1.5 text-[#0A1A2F] font-semibold group-hover:text-[#F5A623]">
                                            Baca Artikel <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
                                        </span>
                                    </div>
                                </div>
                            </motion.article>
                        );
                    })}
                </div>

                <div className="mt-12 bg-white border border-slate-200 rounded-3xl p-7 md:p-9 flex flex-col md:flex-row items-center md:items-start gap-5 md:gap-8 justify-between" data-testid="articles-bottom-cta">
                    <div className="text-center md:text-left">
                        <h3 className="font-display font-semibold text-xl md:text-2xl text-[#0A1A2F]">Bingung mulai dari mana?</h3>
                        <p className="mt-1.5 text-sm text-slate-600 max-w-md">Konsultasi gratis dengan Counselor — kami bantu memetakan langkahmu dari awal.</p>
                    </div>
                    <a
                        href={waUrl(WA_MESSAGES.article)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-cta="cta_articles_whatsapp"
                        data-testid="articles-cta-whatsapp"
                        className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1FB454] text-white rounded-full px-6 py-3 font-bold text-sm transition shadow-[0_4px_14px_0_rgba(37,211,102,0.35)]"
                    >
                        <MessageCircle className="w-4 h-4" /> Konsultasi via WhatsApp
                    </a>
                </div>
            </div>
        </section>
    );
}
